/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsManagementListNewsResponse } from './NewsManagementListNewsResponse';

export type NewsManagementListNewsResponseApiRespoonse = {
    data?: NewsManagementListNewsResponse;
    status?: NewsManagementListNewsResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace NewsManagementListNewsResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

